import { Notification } from 'react-admin';

const MyNotification = props => <Notification {...props} />;

export default MyNotification;